import React, { useState, useEffect, useCallback, useRef } from "react";
import { INDEX_URL, CUST, icons, FLAVOR, logos, markers, images } from "../../helpers/constants";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { marker } from 'leaflet';
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import * as request from "../../services/FetchService";
import { useParams } from "react-router";
import { useIsMobile } from '../../helpers/customHooks';

const StolenModeMap = (props) => {
    const { t } = useTranslation();
    let params = useParams();
    const intervalId = useRef(null);
    const token = params.token
    const [mapType, setMapType] = useState(0);
    const [data, setData] = useState();
    const [lastPosition, setLastPosition] = useState()
    const lightTiles = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    const darkTiles = 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'; // Example of dark mode
    const [looping, setLooping] = useState(false)
    const [initialMove, setInitialMove] = useState(false)
    const customDeviceIcon = L.icon({
        iconUrl: markers.blue.default,
        iconSize: [45, 45], // Width and height in pixels
        iconAnchor: [22.5, 45], // Point of the icon which corresponds to the marker's location
        popupAnchor: [0, -45], // Point from which the popup should open relative to the iconAnchor
    });
    const MOBILE = useIsMobile();

    useEffect(() => {
        getInitialInfo()
    }, [])

    const getInitialInfo = () => {
        request.postUnique("", "other/v1/devices/stolen/positions", { token: token }).then((response) => {
            if(response?.data?.error){
                toast.error(response?.data?.error?.message)
                stopInterval();
                setLooping(false)
                return
            }
            if (response.data){
                setData(response?.data?.response)
                const lat = response?.data?.response?.latitude
                const lng = response?.data?.response?.longitude
                setLastPosition([lat, lng])
                setLooping(true)
                toast.success(t("toast.saved"));
            }else{
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }
        })
    }

    const updateData = useCallback(() => {
        if(token)

            request.postUnique("", "other/v1/devices/stolen/positions", { token: token }).then((response) => {
                if(response?.data?.error){
                    toast.error(response?.data?.error?.message)
                    stopInterval();
                    setLooping(false)
                    return
                }
                if(!response?.data?.successful) return
                if (response.data) {
                    setData(response?.data?.response)
                    const lat = response?.data?.response?.latitude
                    const lng = response?.data?.response?.longitude
                    setLastPosition([lat, lng])
                    // toast.success(t("toast.data_updated"));
                }else{
                    const msg = response?.data?.message
                    toast.error(msg ?? t("toast.error"))
                }
            })

    }, [data]);

    const startInterval = useCallback(() => {
        setLooping(true);
        intervalId.current = setInterval(updateData, 10000);
    }, [updateData]);

    const stopInterval = useCallback(() => {
        setLooping(false);
        if(intervalId.current){
            clearInterval(intervalId.current)
        }
    }, []);


    useEffect(() => {
        if (looping) {
            startInterval();
        } else {
            stopInterval();
        }
        return () => {
            stopInterval(); // Cleanup function to stop interval when unmounting
        };
    }, [looping, startInterval, stopInterval]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                stopInterval(); // Pause interval when window is in background
            } else {
                startInterval(); // Resume interval when window is in foreground
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            stopInterval(); // Cleanup function to stop interval when unmounting
        };
    }, [startInterval, stopInterval]);    



    const calculateAge = (fixtime) => {
        if (!fixtime) return "";

        const timestamp = new Date(fixtime);
        const currentTime = new Date();
        const diffMs = currentTime - timestamp; // milliseconds

        const diffSec = Math.floor(diffMs / 1000);
        const diffMin = Math.floor(diffSec / 60);
        const diffHr = Math.floor(diffMin / 60);

        if (diffHr > 0) {
            return (<p>{t("stolenmode.position_age_1")} <span className="bold">{diffHr} {t("stolenmode.hour", {count : diffHr})}</span> {t("stolenmode.position_age_3")}</p>)
        } else if (diffMin > 0) {
            return (<p>{t("stolenmode.position_age_1")} <span className="bold">{diffMin} {t("stolenmode.minute", {count : diffMin})}</span> {t("stolenmode.position_age_3")}</p>)
        } else {
            return (<p>{t("stolenmode.position_age_1")} <span className="bold">{diffSec} {t("stolenmode.second", {count : diffSec})}</span> {t("stolenmode.position_age_3")}</p>)
        }
    };

    const toggleMapMode = () => {
        const value = mapType > 2 ? 1 : mapType + 1
        setMapType(value)
    }

    const StolenMappy = ({ position }) => {
          const map = useMap();
            useEffect(() => {
                if (position && position[0] !== 0 && position[1] !== 0 && !initialMove) {
                setInitialMove(true)
                map.setView(position);
                }
            }, [position]);
        return null
    }

    return(
        <>
        <MapContainer center={lastPosition ?? [59, 18]} zoom={13} style={{ position: 'relative', height: '100vh', width: '100%' }} zoomControl={false}>
            <StolenMappy position={lastPosition} />
            <TileLayer
                url={
                    mapType === 1 
                    ? lightTiles 
                    : darkTiles
                }
            />
            <div className="stolenmode-map top-left logo px-4 py-3">
                <img src={logos.big} alt="" className="w-100"/>
            </div>

            {data &&
                <div className={`d-flex ${MOBILE ? "flex-column rounded16": "flex-row justify-content-between mb-2 px-2"} stolenmode-map bottom-0 w-100`}>
                {/* <div className="stolenmode-map bottom-left px-2 py-2 data bg-white"> */}
                    <div className={`d-flex ${MOBILE ? "w-100": "w-25 rounded16"} bg-white p-2 `}>
                        <div className="d-flex flex-column ">
                            <p>{t("stolenmode.fetching_data")} <span className="me-2 size_15 spinner-grow"/></p>
                            {calculateAge(data?.fixtime)}
                            <p>{t("stolenmode.speed")}: <span className="bold">{data?.speed?.toFixed(0) ?? 0} km/h</span></p>
                        </div>
                        <img src={
                        mapType === 1 
                            ? icons.dark_map 
                            : icons.light_map
                            } alt="" className="ms-auto map-type-img cursor-pointer" onDoubleClick={(e) => e.stopPropagation()} onClick={() => toggleMapMode()}/>
                    </div>
                {/* </div> */}

                {/* <div className="stolenmode-map bottom-right data bg-white overflow-hidden"> */}
                    <div className={`d-flex ${MOBILE ? "w-100": "w-25 rounded16"} align-items-center bg-white p-2 position-relative scrollable-y `} style={{height: MOBILE ? "150px" : ""}}
                        onWheel={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onTouchStart={(e) => e.stopPropagation()}
                        onTouchMove={(e) => e.stopPropagation()}
                    >
                        <img src={data?.image_url ?? images.placeholder_img} alt="" className="user-info"/>
                        <div className="d-flex flex-column align-self-center py-3 ms-3 me-5">
                            <h4>{t("stolenmode.info_user")}</h4>
                            <p>{data?.description ?? t("stolenmode.no_info")}</p>
                            <img src={icons.info_icon} alt="" className="position-absolute top-0 end-0 me-2 mt-2" />
                        </div>
                    </div>   
                </div>
            }

            {/* </div> */}

            {lastPosition && <Marker position={lastPosition} icon={customDeviceIcon} />}
            

            {/* <Marker position={position}>
                <Popup>
                    This is Stockholm!
                </Popup>
            </Marker> */}
        </MapContainer>
        </>
    )
    
}
export default StolenModeMap;
